<template>
  <ConfirmationDialog
    :model-value="modelValue"
    :loading="loading"
    v-bind="$attrs"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-alert
      density="compact"
      type="warning"
      variant="tonal"
      icon="mdi-alert-outline"
      class="ma-0"
    >
      Are you sure you want to archive this {{ label }}?
    </v-alert>
  </ConfirmationDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import ConfirmationDialog from '@/bundles/Common/components/ConfirmationDialog.vue';

export default defineComponent({
  name: 'ArchiveConfirmationDialog',

  components: { ConfirmationDialog },

  props: {
    modelValue: Boolean,
    loading: Boolean,
    label: { type: String, required: true },
  },

  emits: ['update:modelValue'],
});
</script>
